<!-- TEMPLATE FOR MODAL DIALOG -->

<div class="modal-header d-flex justify-content-between align-items-start">
  <div class="modal-title">
      <h3>Preliminära leveransveckor</h3>
      <p>Se uppskattade leveranstider för olika produktkategorier.
        Leveransveckorna är preliminära och kan komma att ändras vid bekräftelse av en
        offert beroende på fasta leveransdagar, förändrad kapacitet och helgdagar.</p>
        <p>Leveranstiderna gäller för samtliga träkulörer och de 10 standard-alukulörerna.</p>
  </div>
  <button type="button" class="btn-close" (click)="close()" aria-label="Close"></button>
</div>

<div class="modal-body">
  <div class="d-flex flex-column flex-wrap flex-md-row justify-content-between align-items-md-center gap-5">
    <div class="border border-radius p-2 flex-fill">
      <div class="row gy-2">
        <div class="col-12 col-md-3">
          <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
            <div>
              <p-avatar size="large" shape="circle" class="delivery-avatar-reseller">
                <span><i class="fa-duotone fa-calendar"></i></span>
              </p-avatar>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="d-flex flex-column align-items-center align-items-md-start gap-1">
            <div>Tidigast leverans ÅF</div>
            <div><h3>{{ formatDeliveryWeek(earliestResellerWeek()) }}</h3></div>
            <div>{{ formatDeliveryYear(earliestResellerWeek()) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="border border-radius p-2 flex-fill">
      <div class="row gy-2">
        <div class="col-12 col-md-3">
          <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
            <div>
              <p-avatar size="large" shape="circle" class="delivery-avatar-object">
                <span><i class="fa-duotone fa-buildings"></i></span>
              </p-avatar>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="d-flex flex-column align-items-center align-items-md-start gap-1">
            <div>Tidigast leverans Objekt</div>
            <div><h3>{{ formatDeliveryWeek(earliestObjectWeek()) }}</h3></div>
            <div>{{ formatDeliveryYear(earliestObjectWeek()) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="border border-radius p-2 flex-fill">
      <div class="row gy-2">
        <div class="col-12 col-md-3">
          <div class="h-100 d-flex flex-column flex-md-row align-items-center justify-content-center">
            <div>
              <p-avatar size="large" shape="circle" class="delivery-avatar-update" >
                <span><i class="fa-duotone fa-clock"></i></span>
              </p-avatar>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-9">
          <div class="d-flex flex-column align-items-center align-items-md-start gap-1">
            <div>Uppdaterad</div>
            <div><h3>{{updatedDate()?.datePart}}</h3></div>
            <div>{{updatedDate()?.timePart}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-body">
  <div class="d-flex flex-row justify-content-start justify-content-md-end align-items-center gap-3 gap-md-5 ms-3 me-md-3">
    <div class="d-flex align-items-center gap-2 gap-md-3"><p-overlaybadge severity="success" /> 0-6 veckor</div>
    <div class="d-flex align-items-center gap-2 gap-md-3"><p-overlaybadge severity="warn" /> 7-8 veckor</div>
    <div class="d-flex align-items-center gap-2 gap-md-3"><p-overlaybadge severity="danger" /> 9+ veckor</div>
  </div>
  <div class="d-flex flex-row justify-content-start justify-content-md-end align-items-center gap-3 mt-3 gap-md-5 ms-3 me-md-3">
    <i>Nuvarande vecka: <span class="fw-bolder">{{currentWeek}}</span></i>
  </div>
</div>

@if(errorMessage()) {
  <div class="modal-body">
    <p-message severity="error">{{errorMessage()}}</p-message>
  </div>
} @else {
  <div class="modal-body">
    <p-accordion [value]="null" [multiple]="true">
      @for(group of estimatedDlvWeeks() | keyvalue; track group.key; let i = $index) {
        <p-accordion-panel [value]="i">
          <p-accordion-header>
            <div class="d-flex justify-content-between align-items-center gap-3 w-100">
              <div class="delivery-group">
                <p-avatar size="large" shape="circle" class="delivery-avatar-reseller">
                  <span><i class="fa-duotone fa-window-frame"></i></span>
                </p-avatar>
                <div class="delivery-group-details">
                  <h4>{{ group.key }}</h4>
                  <div class="mt-2">{{group.value.length}} produkter</div>
                </div>
              </div>
              <div class="d-flex flex-column gap-2 delivery-week-info">
                @let resellerWeek = getEarliestWeek(group.value, 'WEEK');
                @let resellerSeverity = weekSeverityColor(resellerWeek);
                <div>ÅF</div>
                <div><p-tag [severity]="resellerSeverity" [pTooltip]="(resellerWeek ? 'Tidigast leveransvecka för ÅF i det här produktsortimentet.' : 'Kontakta kundtjänst för mer information.')" [value]="formatDeliveryWeek(resellerWeek)" /></div>
              </div>
              <div class="d-flex flex-column gap-2 delivery-week-info">
                @let objectWeek = getEarliestWeek(group.value, 'WEEKOBJECT');
                @let objectSeverity = weekSeverityColor(objectWeek);
                <div>Objekt</div>
                <div><p-tag [severity]="objectSeverity" [pTooltip]="(objectWeek ? 'Tidigast leveransvecka för objekt i det här produktsortimentet.' : 'Kontakta kundtjänst för mer information.')" [value]="formatDeliveryWeek(objectWeek)" /></div>
              </div>
              <div class="d-flex flex-column gap-2 delivery-week-info">
                <div class="align-self-end me-3">Visa produkter</div>
              </div>
            </div>

          </p-accordion-header>
            <p-accordion-content>
              <p-table [value]="group.value" [size]="'small'" [rowHover]="true">
                <ng-template #header>
                  <tr>
                      <th>Produkt</th>
                      <th>ÅF (Standard)
                        <span class="ms-2"><i class="fa-duotone fa-circle-info" pTooltip="Leveransveckorna anges som årvecka/dag" tooltipPosition="top"></i></span>
                      </th>
                      <th>Objekt
                        <span class="ms-2"><i class="fa-duotone fa-circle-info" pTooltip="Leveransveckorna anges som årvecka/dag" tooltipPosition="top"></i></span>
                      </th>
                  </tr>
                </ng-template>
                <ng-template #body let-product>
                  @let resellerWeek = product.WEEK;
                  @let resellerSeverity = weekSeverityColor(resellerWeek);
                  @let objectWeek = product.WEEKOBJECT;
                  @let objectSeverity = weekSeverityColor(objectWeek);
                  <tr>
                    <td>{{ product.PRODUCT || group.key }}</td>
                    <td>
                      <p-tag [severity]="resellerSeverity" [value]="formatDeliveryWeek(resellerWeek)" />
                      @if(product.WEEK) {
                        <span class="ms-2 text-primary text-sm">{{product.WEEK}}/{{formatDeliveryDay(product.WEEKDAY)}}</span>
                      }
                    </td>
                    <td>
                      <p-tag [severity]="objectSeverity" [value]="formatDeliveryWeek(objectWeek)" />
                      @if(product.WEEKOBJECT) {
                        <span class="ms-2 text-primary text-sm">{{product.WEEKOBJECT}}/{{formatDeliveryDay(product.WEEKDAYOBJECT)}}</span>
                      }
                    </td>
                  </tr>
                </ng-template>
              </p-table>

            </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
}

<div class="modal-body">
  <div class="d-flex justify-content-between gap-2">
    <button class="btn btn-sm btn-outline-primary" (click)="downloadPDF()"><i class="fa-duotone fa-file-pdf me-2"></i> Öppna som PDF</button>
    <button class="btn btn-sm btn-primary" (click)="close()">Stäng</button>
  </div>
</div>

